/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CNAE = {
  properties: {
    code: {
      type: 'string',
    },
    description: {
      type: 'string',
    },
  },
} as const;
